import { getFromLocalStorage, saveToLocalStorage, getFromSessionStorage, saveToSessionStorage, } from "../../../utils/misc";
export class Storage {
    static fromSessionStorage(key) {
        return getFromSessionStorage(key);
    }
    static fromLocalStorage(key) {
        return getFromLocalStorage(key);
    }
    static saveOnLocalStorage(key, data) {
        saveToLocalStorage(key, data);
    }
    static saveOnSessionStorage(key, data) {
        saveToSessionStorage(key, data);
    }
}
